var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tour-categories font-text"},_vm._l((_vm.categories),function({ code, name }){return _c('a',{key:code,staticClass:"tour-categories__item",attrs:{"href":`/tours/type/${code}`,"target":"_blank"}},[_vm._v(" "+_vm._s(name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }